// Per-page SEO via React 19 native document metadata (hoisted to <head>).
import { useEffect } from "react";

const SITE = "https://voluntoldhq.com";
const DEFAULT_TITLE = "Voluntold — Coaching resources for the voluntold";
const DEFAULT_DESC =
  "Bench-tested coaching and youth-sports-parent resources by Kyto — articles, free tools, and toolkits for the coach who got talked into it.";

export default function Seo({ title, description, path = "", image, type = "website", article, jsonLd, noindex = false, brand = "Voluntold", rawTitle }) {
  const url = `${SITE}${path}`;
  const img = article ? `${SITE}/api/og/${article.slug}.png` : image || `${SITE}/brand/social/og-image-1200x630.png`;
  const fullTitle = rawTitle || (title ? `${title} · ${brand}` : DEFAULT_TITLE);
  const desc = description || DEFAULT_DESC;
  // The static default og/twitter image in index.html would otherwise shadow this page's image.
  useEffect(() => { document.querySelectorAll("meta[data-default-og]").forEach((m) => m.remove()); }, []);

  const ld = jsonLd || (article
    ? {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: article.title,
        description: desc,
        image: img,
        datePublished: article.date,
        dateModified: article.updated_at || article.date,
        author: {
          "@type": "Person",
          name: "Kyto",
          description: "CSPC-certified coach — 20 years coaching on top of 20 years playing.",
        },
        publisher: { "@type": "Organization", name: "Voluntold", logo: { "@type": "ImageObject", url: `${SITE}/brand/email/wordmark-on-light.png` } },
        mainEntityOfPage: { "@type": "WebPage", "@id": url },
        articleSection: article.category,
      }
    : null);

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={brand} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {ld && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />}
    </>
  );
}
